/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPrescription } from 'app/shared/model/prescription.model';
import { IDiagLab } from 'app/shared/model/diag-lab.model';

export interface IDiaglabHistory {
  id?: string;
  billNumber?: string;
  noOfItems?: number | null;
  excluded?: string | null;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  prescription?: IPrescription | null;
  diagLab?: IDiagLab | null;
}

export const defaultValue: Readonly<IDiaglabHistory> = {
  active: false,
};
